// Blog and Press Release Specific Logic
$(function () {
  // Blog Featured Slider
  if ($(".featured-blog-slider").length) {
    setTimeout(function () {
      $(".featured-blog-slider").slick({
        dots: true,
        dotsClass: "slick-dots",
        appendDots: $(".featured-blog-slider"),
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: true,
        prevArrow: `<button type="button" class="slick-prev" aria-label="Previous">
        <svg width="11" height="11" viewBox="0 0 11 11" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path fill-rule="evenodd" clip-rule="evenodd" d="M5.79199 0.292856C5.40149 -0.0976361 4.76845 -0.0976001 4.37793 0.292856L0.29004 4.38075C0.242264 4.42858 0.199457 4.4813 0.16211 4.53797C0.118386 4.60429 0.0848914 4.67512 0.0585948 4.74793C0.0417577 4.7945 0.0264302 4.84201 0.0166026 4.89149C-0.0342587 5.14683 0.0163709 5.41732 0.166017 5.64149C0.178595 5.66033 0.192263 5.67827 0.206056 5.69618C0.232114 5.72998 0.259062 5.76382 0.29004 5.79481L4.37793 9.88172C4.76845 10.2722 5.40149 10.2722 5.79199 9.88172C6.18227 9.49121 6.18236 8.85812 5.79199 8.46766L3.41309 6.08778L9.17188 6.08778C9.72403 6.08778 10.1717 5.63988 10.1719 5.08778C10.1719 4.53549 9.72416 4.08778 9.17188 4.08778L3.41113 4.08778L5.79199 1.70692C6.18242 1.31641 6.18241 0.683359 5.79199 0.292856Z" fill="#0066B5"/>
        </svg>
      </button>`,
        nextArrow: `<button type="button" class="slick-next" aria-label="Next">
        <svg width="11" height="11" viewBox="0 0 11 11" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path fill-rule="evenodd" clip-rule="evenodd" d="M4.37988 0.292856C4.77039 -0.0976365 5.40342 -0.0976006 5.79394 0.292856L9.88184 4.38075C9.92961 4.42858 9.97242 4.4813 10.0098 4.53797C10.0535 4.60429 10.087 4.67511 10.1133 4.74793C10.1301 4.79449 10.1454 4.842 10.1553 4.89149C10.2061 5.14683 10.1555 5.41732 10.0059 5.64149C9.99328 5.66032 9.97961 5.67827 9.96582 5.69618C9.93976 5.72998 9.91281 5.76382 9.88184 5.79481L5.79394 9.88172C5.40342 10.2722 4.77039 10.2722 4.37988 9.88172C3.9896 9.49121 3.98952 8.85812 4.37988 8.46766L6.75879 6.08778L1 6.08778C0.447845 6.08778 0.000211085 5.63988 0 5.08778C0 4.53549 0.447715 4.08778 1 4.08778L6.76074 4.08778L4.37988 1.70692C3.98946 1.31641 3.98946 0.683359 4.37988 0.292856Z" fill="#0066B5"/>
        </svg>
      </button>`,
      });
    }, 100);
  }

  // Related Blogs Slider - Blog Detail Page
  if ($(".related-blogs-slider").length) {
    setTimeout(function () {
      $(".related-blogs-slider").slick({
        slidesToShow: 2,
        slidesToScroll: 1,
        infinite: true,
        arrows: false,
        dots: false,
        draggable: true,
        swipe: true,
        touchMove: true,
        responsive: [
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
              arrows: true,
              dots: true,
              prevArrow:
                '<button type="button" class="slick-prev" aria-label="Previous"></button>',
              nextArrow:
                '<button type="button" class="slick-next" aria-label="Next"></button>',
            },
          },
        ],
      });
    }, 200);
  }

  // --- Blog AJAX Pagination ---
  $(document).on("click", ".blogPaginationClick", function () {
    var $this = $(this);
    var page = $this.data("page");
    var limit = $this.data("limit");
    var category = $this.data("category") || "";
    var $container = $this.closest(".ajax-pagination-container");

    $.ajax({
      url: window.PMR_SETTINGS.baseUrl + "blogs_data_ajax",
      type: "POST",
      data: {
        page: page,
        limit: limit,
        category: category,
        _: new Date().getTime(),
      },
      success: function (response) {
        $("html, body").animate({ scrollTop: 0 }, "slow");
        if ($container.length) {
          $container.html(response);
        } else {
          $(".latest-blog-section").html(response);
        }
      },
    });
  });

  // --- Press Release AJAX Pagination ---
  $(document).on("click", ".pressPaginationClick", function (e) {
    e.preventDefault();
    var $this = $(this);
    var page = $this.data("page");
    var limit = $this.data("limit");
    var $container = $this.closest(".ajax-pagination-container");

    $.ajax({
      url: window.PMR_SETTINGS.baseUrl + "press_release_data_ajax",
      type: "POST",
      data: {
        page: page,
        limit: limit,
        _: new Date().getTime(),
      },
      success: function (response) {
        $("html, body").animate({ scrollTop: 0 }, "slow");
        if ($container.length) {
          $container.html(response);
        } else {
          $("#press-release-ajax-container").html(response);
        }
      },
    });
  });

  // --- Media AJAX Pagination ---
  $(document).on("click", ".mediaPaginationClick", function (e) {
    e.preventDefault();
    var $this = $(this);
    var page = $this.data("page");
    var limit = $this.data("limit");
    var $container = $this.closest(".ajax-pagination-container");

    $.ajax({
      url: window.PMR_SETTINGS.baseUrl + "media_data_ajax",
      type: "POST",
      data: {
        page: page,
        limit: limit,
        _: new Date().getTime(),
      },
      success: function (response) {
        $("html, body").animate({ scrollTop: 0 }, "slow");
        if ($container.length) {
          $container.html(response);
        } else {
          $("#media-ajax-container").html(response);
        }
      },
    });
  });
});
